import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import { WRISTBANDS_ACTIONS } from "../../../../redux/wristbands/actions";
import {
  selectWristbands,
  wristbandsLoaded,
  wristbandsMeta,
  wristbandsFilters
} from "../../../../redux/wristbands/selectors";
import { selectVenues } from "../../../../redux/venues/selectors";
import ListView from "../../../../base/ListView";
import { formatUTCDate } from "../../../../libs/utils";
import { getCrewMemberTransits } from "../../../../services/api/crewMembers";
import { selectEvent } from "../../../../redux/preferences/selectors";
import { toImmutable } from "../../../../libs/immutable-transformer";

class _Tracker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transits: [],
      transitsMeta: {},
      filters: toImmutable({
        "page[number]": 1,
        "page[size]": 50,
        include: "crew-member",
        sort: "-accessed_at"
      })
    };

    this._getData = this._getData.bind(this);
  }

  static propTypes = {
    match: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    this._getData();
  }

  _getData(filters = this.state.filters) {
    getCrewMemberTransits(this.props.match.params.id, filters).then(
      response => {
        this.setState({
          transits: response.data,
          transitsMeta: response.meta
        });
      }
    );
  }

  render() {
    const { transits, transitsMeta, filters } = this.state;

    const listViewConf = {
      dataSet: transits,
      dataMeta: transitsMeta,
      columns: [
        {
          key: "accessedAt",
          value: "Time",
          sort: "accessed_at",
          render: item => formatUTCDate(item.accessedAt, "DD/MM/YYYY HH:mm:ss")
        },
        {
          key: "scannerName",
          value: "Scanner"
        },
        {
          key: "direction",
          value: "Direction"
        }
      ],
      baseFilters: filters,
      filters: [],
      actions: {
        deleteLink: false,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "wristbands"
    };

    return [
      <AdminSubHeader title="Tracker" key="subheader" breadcrumbs={[]}>
        <Link
          to="/admin/wristbands/create"
          className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
        >
          <i className="la la-plus" />
        </Link>
      </AdminSubHeader>,
      <div className="m-content" key="content">
        {wristbandsLoaded && (
          <div className="row">
            <div className="col-xl-12">
              <ListView
                config={listViewConf}
                handleFilterUpdate={this._getData}
              />
            </div>
          </div>
        )}
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadWristbands: () => dispatch(WRISTBANDS_ACTIONS.loadAllRequest()),
  createWristband: values => dispatch(WRISTBANDS_ACTIONS.createRequest(values)),
  updateWristband: (id, values) =>
    dispatch(WRISTBANDS_ACTIONS.updateRequest(id, values)),
  deleteWristband: id => dispatch(WRISTBANDS_ACTIONS.deleteRequest(id)),
  updateFilters: filters => dispatch(WRISTBANDS_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    venues: selectVenues(state),
    wristbands: selectWristbands(state),
    wristbandMeta: wristbandsMeta(state),
    wristbandsLoaded: wristbandsLoaded(state),
    filters: wristbandsFilters(state),
    event: selectEvent(state)
  };
};

const Tracker = connect(mapStateToProps, mapDispatchToProps)(_Tracker);

export default Tracker;
